module.exports = __webpack_public_path__ + "fonts/Aq+UcR29.woff2";